<template>
  <div id="app">
    <div class="wrap" :class="{admin: adminModeYn, positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />

      <div class="admin-wrap" v-if="adminModeYn">
        <span class="ft--2xlg">{{ $store.getters.getCpCd }}-{{ $store.getters.getStoreCd }}-{{ $store.getters.getShopId }}-{{ $store.getters.getPosNo }}</span>
        <span class="ft--3xlg">Admin Mode</span>
        <button
          @mouseup="
            $store.dispatch('setAdminModeYn', false);
            basketDel();
          "
          class="btn-exit btn-anim"
        >
          {{ $t('User.Order.msg19') }}
        </button>
      </div>
      <!-- <div class="hidden-button-wrap" v-if="!adminModeYn">
        <div
          class="hidden-button left"
          @mouseup="
            if (adminCnt2 == 0) adminTimeout2();
            adminLogin2();
          "
          style="width: 100px; height: 100px"
        ></div>
        <div
          class="hidden-button right"
          style="width: 100px; height: 100px"
          @mouseup="
            if (adminCnt == 0) adminTimeout();
            adminLogin();
          "
        ></div>
      </div> -->
      <div class="main main--e">
        <div class="main__body">
          <div class="content">
            <div class="menu__list">
              <!-- one item -->
              <!-- 아이템 목록 -->
              <div
                class="menu__item--col04 btn-anim"
                v-for="(item, i) in kioskItem.slice((currentPage - 1) * pageCount, currentPage * pageCount)"
                :key="item"
                @mouseup="
                  if (item.SLDOUT_YN != 'Y' && (item.ALLERGY_LIST != null ? !allergyCheck(item.ALLERGY_LIST) : true)) menuPersonalDetail(item);
                  $logInfo(`Item Select DIS_ITEM_CD : ${item.DIS_ITEM_CD}`);
                "
                :class="{
                  disabled: item.SLDOUT_YN == 'Y' || (item.ALLERGY_LIST != null ? allergyCheck(item.ALLERGY_LIST) && item.SLDOUT_YN == 'N' : false),
                  'large first': i == 0,
                  'large last': i == 9,
                }"
              >
                <div class="err-msg" v-if="item.ALLERGY_LIST != null ? allergyCheck(item.ALLERGY_LIST) && item.SLDOUT_YN == 'N' : false">
                  <span class="ico-err"></span>
                  <span class="txt">{{ $t('User.Order.msg7') }}</span>
                </div>
                <div class="err-msg" v-if="item.SLDOUT_YN == 'Y'">
                  <span class="txt">{{ $t('User.Order.msg8') }}</span>
                </div>
                <div class="tag-area" v-if="item.TAG != '' && item.TAG != null">
                  <template v-for="i in item.TAG.split(',').length - 1" :key="i">
                    <span class="tag--red" v-if="i != 0" :class="[i == 0 ? 'violet' : 'orange']">{{ item.TAG.split(',')[i].replaceAll('#', '') }}</span>
                  </template>
                </div>
                <div class="tag-area" v-if="item.EVNT_ITEM_CD != '' && item.EVNT_ITEM_CD != null && item.DC_ABLE_YN === 'Y'">
                  <span class="tag--red">SALE</span>
                </div>
                <div class="img-area img--radius">
                  <img :src="item.SUB_ITEM_IMG_FILE_URL == null ? replaceToDefaultImg : item.SUB_ITEM_IMG_FILE_URL" alt="" @error="replaceToDefaultImg" />
                </div>
                <div class="toggle-wrap" v-if="adminModeYn" @mouseup="soldout()">
                  <input type="checkbox" :id="item.DIS_ITEM_CD" hidden :checked="item.SLDOUT_YN != 'Y'" />
                  <label :for="item.DIS_ITEM_CD" class="toggle-switch">
                    <span class="on">{{ $t('User.Order.msg18') }}</span>
                    <span class="off">{{ $t('User.Order.msg8') }}</span>
                    <span class="toggle-btn"></span>
                  </label>
                </div>
                <div class="w-box">
                  <div class="menu__name ft--lg ft--bold">{{ item.DIS_ITEM_NM }}</div>
                  <div class="ft--lg ft--bold">{{ $displayUprc($detailUprc(item)) }}</div>
                </div>
              </div>
            </div>

            <MainPaging :currentPage="currentPage" :pageCount="pageCount" :totalCount="totalCount" @changePage="changePage" />
            <button
              v-if="algYn"
              :class="{active: allergySelectedList.length > 0, disabled: allergySelectedList.length == 0}"
              class="btn--line-b btn--shadow btn-anim"
              @mouseup="allergyYn = true"
            >
              <i class="ico-check"></i><span>{{ $t('User.Order.msg20') }}</span>
            </button>
          </div>
        </div>
        <div class="main__footer">
          <div class="total-area">
            <dl class="total-price">
              <dt>{{ $t('User.Order.msg21') }}</dt>
              <dd class="hasline">{{ totalQty }}</dd>
              <dt class="pd-dt">{{ $t('User.Order.msg22') }}</dt>
              <dd>{{ totalUprc }}</dd>
            </dl>
            <div class="box-gray scroll-area" id="basketScroll">
              <table class="tb-hdr-fix basket-a">
                <thead>
                  <tr>
                    <th></th>
                    <th>{{ $t('User.Order.msg23') }}</th>
                    <th>{{ $t('User.Order.msg24') }}</th>
                    <th>{{ $t('User.Order.msg25') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, i) in baskets">
                    <tr>
                      <td>
                        <button
                          class="btn-delete btn--shadow btn-anim"
                          @mouseup="
                            delBasket(i);
                            $logInfo(`Basket Delete DIS_ITEM_CD : ${item.DIS_ITEM_CD}`);
                          "
                        >
                          삭제
                        </button>
                      </td>
                      <td>{{ item.DIS_ITEM_NM }}</td>
                      <td>
                        <div class="count-num">
                          <button
                            class="btn-touch40 btn-anim"
                            @mouseup="
                              if (item.SALES_QTY > 1) item.SALES_QTY--;
                              changeQty(i, item.SALES_QTY);
                              $logInfo(`Basket Qty Change DIS_ITEM_CD : ${item.DIS_ITEM_CD}, Qty : ${item.SALES_QTY}`);
                            "
                          >
                            <span class="btn-minus--mini">빼기</span>
                          </button>
                          <span class="txt-btwbtn">{{ item.SALES_QTY }}</span>
                          <button
                            class="btn-touch40 btn-anim"
                            @mouseup="
                              if (item.SALES_QTY > 0) item.SALES_QTY++;
                              changeQty(i, item.SALES_QTY);
                              $logInfo(`Basket Qty Change DIS_ITEM_CD : ${item.DIS_ITEM_CD}, Qty : ${item.SALES_QTY}`);
                            "
                          >
                            <span class="btn-plus--mini">더하기</span>
                          </button>
                        </div>
                      </td>
                      <td>{{ $displayUprc(item.SALES_QTY * ($detailUprc(item) + totOptUprc(item))) }}</td>
                    </tr>
                    <tr class="item-option" v-if="item.OPTIONITEM.length > 0">
                      <td colspan="4" class="ellipsis" style="text-align: left">
                        ㄴ<span v-for="(option, z) in item.OPTIONITEM" :key="option">{{ option.ITEM_NM }}{{ z == item.OPTIONITEM.length - 1 ? '' : ',' }}</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div class="table-btn">
              <button
                name="basketUpDw"
                id="upBtn"
                :style="[baskets.length == 0 ? {opacity: '0.4'} : '']"
                class="btn-tb-btm up btn-anim"
                @mouseup="this.basketScrollMove(-50)"
              >
                <i class="ico-arr-u">위</i>
              </button>
              <button
                name="basketUpDw"
                id="dwBtn"
                :style="[baskets.length == 0 ? {opacity: '0.4'} : '']"
                class="btn-tb-btm down btn-anim"
                @mouseup="this.basketScrollMove(+50)"
              >
                <i class="ico-arr-d">아래</i>
              </button>
            </div>
          </div>
          <div class="btn-area">
            <!--도움기능-->
            <button class="btn--line btn--md btn-anim" @mouseup="helperYn = true">
              <i class="ico-helper ico-sm"></i><span>{{ $t('User.Order.msg11') }}</span>
            </button>
            <!-- 장바구니 삭제 -->
            <button class="btn btn--square-lg btn--shadow btn-anim" :disabled="baskets.length == 0" @mouseup="basketDelYn = true">
              <i :style="[baskets.length == 0 ? {opacity: '0.4'} : '']" class="ico-delete-48"></i><span>{{ $t('User.Order.msg15') }}</span>
            </button>
            <!-- 홈으로 -->
            <button class="btn btn--square-lg btn--shadow btn--violet btn-anim" @mouseup="alertHomeYn = true">
              <i class="ico-home-w"></i><span>{{ $t('User.Order.msg9') }}</span>
            </button>
            <!-- 주문 -->
            <button v-show="!adminModeYn" class="btn btn--shadow btn--2xlg btn--color btn-anim" :disabled="baskets.length == 0" @mouseup="setBasketOrder()">
              {{ $t('User.Order.msg17') }}
            </button>
            <button
              v-show="adminModeYn"
              class="btn btn--square-lg btn--shadow btn-anim btn--admin"
              :disabled="baskets.length == 0"
              @mouseup="RegistrationPayOrder('USED_SALE')"
            >
              {{ $t('User.Order.msg28') }}
            </button>
            <button
              v-show="adminModeYn"
              class="btn btn--square-lg btn--shadow btn-anim btn--admin"
              :disabled="baskets.length == 0"
              @mouseup="RegistrationPayOrder('CASH')"
            >
              {{ $t('User.Order.msg29') }}
            </button>
          </div>
        </div>
      </div>
      <MenuPersonalVue
        @setBasket="setBasket"
        @setSideBasket="setSideBasket"
        @closeMenuPersonal="menuPersonalYn = false"
        @modalSoldout="modalSoldout"
        :menuPersonalYn="menuPersonalYn"
        :itemObj="itemObj"
        v-if="menuPersonalYn == true"
      />
      <OrderSelect @closeOrderSelect="orderSelectYn = false" :orderSelectYn="orderSelectYn" @setOrder="setOrder" />
      <MenuEvent @closeMenuEvent="menuEventYn = false" v-if="menuEventYn" :menuEventYn="menuEventYn" :baskets="baskets" />

      <BasketDel
        @closeBasket="basketDelYn = false"
        @setDel="
          basketDel();
          $logInfo(`Basket All Delete`);
        "
        v-if="basketDelYn"
      />

      <AdminLogin v-if="adminLoginYn" @closeAdminLogin="adminLoginYn = false" />

      <RegistrationPay
        @closeRegisOrder="registrationPayYn = false"
        @regisOrder="
          registrationPayYn = false;
          registrationIngYn = true;
        "
        v-if="registrationPayYn"
      />
      <RegistrationIng
        @regisIngClose="
          registrationIngYn = false;
          registrationFinishYn = true;
          basketDel();
        "
        :settleType="settleType"
        @paymentError="paymentError"
        v-if="registrationIngYn"
      />
      <RegistrationFinish @closeRegis="registrationFinishYn = false" v-if="registrationFinishYn" :settleType="settleType" />

      <Helper
        @setDarkYn="
          $store.commit('setDarkModeYn');
          helperYn = false;
        "
        @setHelper="
          helperYn = false;
          staffCallFinishYn = true;
        "
        @setHelperHeight="
          $store.commit('setHelperHeightYn');
          helperYn = false;
        "
        @closeHelper="helperYn = false"
        :helperYn="helperYn"
      />

      <StaffCall
        @closeStaffCall="staffCallYn = false"
        @setStaffCall="
          staffCallYn = false;
          staffCallFinishYn = true;
        "
        :staffCallYn="staffCallYn"
      />
      <StaffCallFinish @closeStaffCallFinish="staffCallFinishYn = false" :staffCallFinishYn="staffCallFinishYn" />

      <AlertHome
        :alertHomeYn="alertHomeYn"
        @closeAlert="alertHomeYn = false"
        @setHome="
          $store.dispatch('setAdminModeYn', false);
          $router.push('/user/idle');
        "
      />

      <Allergy @closeAllergy="allergyYn = false" :allergySelectedList="allergySelectedList" @setAllergy="setAllergy" v-if="allergyYn" />
      <AlertVue :text="this.text" :message="this.message" v-if="alertYn" @setYes="setYes" />
      <PaymentError @paymentError="paymentError" @closeModal="paymentErrorYn = false" v-if="paymentErrorYn" />
    </div>
  </div>
</template>
<script>
import helperHeight from '@/components/common/HelperHeight.vue';
import orderSelect from '@/components/modal/order/OrderSelect.vue';
import menuEvent from '@/components/modal/order/MenuEvent.vue';
import menuPersonalVue from '@/components/modal/order/MenuPersonal.vue';
import mainPaging from '@/components/common/MainPaging.vue';
import basketDel from '@/components/modal/alert/BasketDel.vue';
import adminLogin from '@/components/modal/admin/AdminLogin.vue';
import registrationPay from '@/components/modal/admin/RegistrationPay.vue';

import registrationIng from '@/components/modal/alert/RegistrationIng.vue';
import registrationFinish from '@/components/modal/alert/RegistrationFinish.vue';

import chargeHelper from '@/js/common/chargeHelper.js';
import audioHelper from '@/js/common/audioHelper.js';
import _ from 'lodash';

//편의기능
import helper from '@/components/modal/Helper.vue';
import staffCall from '@/components/modal/StaffCall.vue';
import staffCallFinish from '@/components/modal/StaffCallFinish.vue';
import alertHome from '@/components/modal/alert/AlertHome.vue';

//알레르기
import allergy from '@/components/modal/order/Allergy.vue';

import axios from 'axios';
import alertVue from '@/components/modal/alert/AlertSuccess.vue';
import paymentError from '@/components/modal/alert/PaymentError.vue';

let scheduler = null;
export default {
  name: 'order1',
  methods: {
    paymentError() {
      this.registrationIngYn = false;
      //this.paymentErrorYn = true;
      this.text = this.text = this.$t('Admin.Common.msg1');
      this.alertYn = true;
    },
    setYes() {
      this.text = '';
      this.message = '';
      this.alertYn = false;
    },
    replaceToDefaultImg(e) {
      // 상품 이미지 로딩 실패 시 기본 이미지 표시
      e.target.src = require('@/assets/images/common/no-image.png');
    },
    soldout() {
      event.stopPropagation(); // 이벤트 전파 차단

      let eventTarget;
      event.currentTarget.childNodes.forEach(function (element) {
        if (element.type == 'checkbox') {
          eventTarget = element;
        }
      });

      let itemCd = eventTarget.id;
      let soldOutYn = eventTarget.checked ? 'Y' : 'N';

      let param = {
        itemCd: itemCd,
        soldOutYn: soldOutYn,
      };
      let index = this.kioskItem.findIndex((item) => {
        return item.DIS_ITEM_CD === itemCd && item.KOS_CLASS_CD === this.activeBtn;
      });

      axios.post('/api/admin/soldout', param).then((response) => {
        if (response.data.status == 0) {
          this.kioskItem[index].SLDOUT_YN = soldOutYn;
          eventTarget.checked = eventTarget.checked ? false : true;
        } else {
          this.text = this.$t('Admin.Common.msg1');
          this.message = response.data.message;
          this.alertYn = true;
          eventTarget.checked = soldOutYn == 'Y' ? true : false;
        }
      });
    },
    modalSoldout(id, checked) {
      let itemCd = id;
      let soldOutYn = checked ? 'Y' : 'N';

      let eventTarget;
      event.currentTarget.childNodes.forEach(function (element) {
        if (element.type == 'checkbox') {
          eventTarget = element;
        }
      });

      let param = {
        itemCd: itemCd,
        soldOutYn: soldOutYn,
      };
      let index = this.kioskItem.findIndex((item) => {
        return item.DIS_ITEM_CD === itemCd && item.KOS_CLASS_CD === this.activeBtn;
      });

      axios.post('/api/admin/soldout', param).then((response) => {
        if (response.data.status == 0) {
          this.kioskItem[index].SLDOUT_YN = soldOutYn;
        } else {
          this.text = this.$t('Admin.Common.msg1');
          this.message = response.data.message;
          this.alertYn = true;
          eventTarget.checked = soldOutYn == 'Y' ? true : false;
        }
      });
    },
    allergyCheck(prodAllergyList) {
      for (var i = 0; i < this.allergySelectedList.length; ++i) {
        if (prodAllergyList.indexOf(this.allergySelectedList[i]) >= 0) {
          return true;
        }
      }
      return false;
    },
    setAllergy(allergySelectedList) {
      this.allergySelectedList = allergySelectedList;
      this.allergyYn = false;
    },
    changePage(page) {
      this.currentPage = page;
    },
    changeQty(num, qty) {
      this.baskets[num].SALES_QTY = qty;
    },

    menuPersonalDetail(item) {
      this.itemObj = {};
      item.idx = this.idx++;
      this.itemObj = item;
      this.menuPersonalYn = true;
    },
    setBasket(prd) {
      let basketYn = true;
      this.baskets.forEach((item) => {
        if (item.DIS_ITEM_CD == prd.DIS_ITEM_CD && JSON.stringify(item.OPTIONITEM) == JSON.stringify(prd.OPTIONITEM)) {
          basketYn = false;
          item.SALES_QTY += prd.SALES_QTY;
        }
      });
      if (basketYn) {
        this.baskets.push(prd);
      }
      this.menuPersonalYn = false;
      this.basketKey++;
      this.$store.dispatch('setOrgBaskets', this.baskets);

      setTimeout(() => {
        this.basketScrollToEnd();
      }, 0);
    },
    setSideBasket(sideList) {
      sideList.forEach((side) => {
        let basketYn = true;
        this.baskets.forEach((item) => {
          if (item.DIS_ITEM_CD == side.OPT_ITEM_CD && item.OPTIONITEM.length == 0) {
            basketYn = false;
            item.SALES_QTY += side.SALES_QTY;
          }
        });

        // 행사 정보
        let eventItem = new Array();
        if (side.EVNT_ITEM_CD != '' && side.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: side.EVNT_CD,
            EVNT_NM: side.EVNT_NM,
            EVNT_KEY_TYPE: side.EVNT_KIND_CD,
            EVNT_FLG_CD: side.EVNT_FLG_CD,
            DC_FLG_CD: side.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: side.SALES_QTY,
            DC_AMT: side.EVNT_DC_AMT,
            EVNT_ITEM_CD: side.EVNT_ITEM_CD,
            DC_RATE: side.EVNT_DC_AMT,
            EVNT_FROM_DATE: side.EVNT_FROM_DATE,
            EVNT_END_DATE: side.EVNT_END_DATE,
            TIME_SALE_YN: side.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: side.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: side.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        if (basketYn) {
          let prd = {
            DIS_ITEM_CD: side.OPT_ITEM_CD,
            DIS_ITEM_NM: side.PRESET_NM,
            CLAS_L_CD: side.CLAS_L_CD,
            CLAS_M_CD: side.CLAS_M_CD,
            CLAS_S_CD: side.CLAS_S_CD,
            TAX_FLG_CD: side.TAX_FLG_CD,
            TAX_RDC_FLG_CD: side.TAX_RDC_FLG_CD,
            NRML_UPRC: side.SALE_UPRC,
            SALES_QTY: side.SALES_QTY,
            SALE_UPRC: side.SALE_UPRC,
            ORG_SALE_UPRC: side.SALE_UPRC,
            SUPY_UPRC: side.SUPY_UPRC,
            MG_RATE: side.MG_RATE,
            CURR_UNIT_TEXT: this.currUnitText,
            DC_ABLE_YN: side.DC_ABLE_YN,
            OPTIONITEM: [],
            DC_AMT: 0.0,
            SALES_AMT: 0,
            VAT_AMT: 0,
            VAT_RATE: 0,
            SVC_AMT: 0,
            EVENTITEM: eventItem,
          };
          let copy = Object.assign({}, prd);
          this.baskets.push(copy);
        }
        this.basketKey++;

        this.$store.dispatch('setOrgBaskets', this.baskets);
      });

      setTimeout(() => {
        this.basketScrollToEnd();
      }, 0);
    },
    delBasket(num) {
      this.baskets.splice(num, 1);
      // this.basketBtnOpacity();
    },
    basketBtnOpacity() {
      var bscroll = document.getElementById('basketScroll');
      if (bscroll.scrollTop == 0) {
        document.getElementById('upBtn').style.opacity = '0.4';
      } else {
        document.getElementById('upBtn').style.opacity = '';
      }
      if (bscroll.scrollTop + bscroll.clientHeight == bscroll.scrollHeight) {
        document.getElementById('dwBtn').style.opacity = '0.4';
      } else {
        document.getElementById('dwBtn').style.opacity = '';
      }
    },
    basketScrollToEnd() {
      /// HSSHIN 20230403 스크롤 맨끝으로 이동
      var bscroll = document.getElementById('basketScroll');
      bscroll.scrollTop = bscroll.scrollHeight;
      // this.basketBtnOpacity();
    },
    basketScrollMove(moveY) {
      var bscroll = document.getElementById('basketScroll');
      bscroll.scrollTop += moveY;
      // this.basketBtnOpacity();
    },
    setOrder(type) {
      this.orderType = type;
      this.orderSelectYn = false;

      let recList = this.$store.getters.getRecommendItem;
      let excludeList = new Array();
      recList.forEach((item) => {
        excludeList.push(item);
        this.baskets.forEach((bas) => {
          if (item.DIS_ITEM_CD === bas.DIS_ITEM_CD) excludeList.pop();
        });
      });

      if (recList.length == 0 || excludeList == 0 || !this.recommendYn) {
        this.$router.replace('/user/payment');
      } else {
        this.menuEventYn = true;
      }
    },
    adminLogin() {
      this.adminCnt++;
      if (this.adminCnt > 4) {
        this.adminCnt = 0;
        this.adminLoginYn = true;
      }
    },
    adminLogin2() {
      this.adminCnt2++;
      if (this.adminCnt2 > 4) {
        this.adminCnt2 = 0;
        this.$router.replace('/admin/login');
      }
    },
    adminTimeout() {
      setTimeout(() => {
        if (this.adminCnt < 5) {
          this.adminCnt = 0;
        }
      }, 2000);
    },
    adminTimeout2() {
      setTimeout(() => {
        if (this.adminCnt2 < 5) {
          this.adminCnt2 = 0;
        }
      }, 2000);
    },
    setBasketOrder() {
      let itemList = new Array();
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      this.baskets.forEach((basket) => {
        let optionitem = new Array();
        basket.OPTIONITEM.forEach((opt) => {
          let option = {
            SALES_QTY: basket.SALES_QTY,
            ITEM_CD: opt.ITEM_CD,
            ITEM_NM: opt.ITEM_NM,
            ITEM_ORG_NM: opt.ITEM_ORG_NM,
            ITEM_PARENT_NM: opt.ITEM_PARENT_NM,
            CLAS_L_CD: opt.CLAS_L_CD,
            CLAS_M_CD: opt.CLAS_M_CD,
            CLAS_S_CD: opt.CLAS_S_CD,
            TAX_FLG_CD: opt.TAX_FLG_CD,
            TAX_RDC_FLG_CD: opt.TAX_RDC_FLG_CD,
            NRML_UPRC: opt.NRML_UPRC,
            SALE_UPRC: opt.SALE_UPRC,
            SALES_UPRC: opt.SALES_UPRC,
            ORG_SALES_UPRC: opt.SALES_UPRC,
            DC_ABLE_YN: opt.DC_ABLE_YN,
            DC_AMT: opt.DC_AMT,
            SALES_AMT: opt.SALES_AMT,
            VAT_AMT: opt.VAT_AMT,
            VAT_RATE: opt.VAT_RATE,
            SVC_AMT: opt.SVC_AMT,
            SUPY_UPRC: opt.SUPY_UPRC,
            MG_RATE: opt.MG_RATE,
          };

          // 행사 정보 (옵션)
          let eventItem = [];
          if (opt.EVNT_ITEM_CD != '' && opt.EVNT_ITEM_CD != null) {
            let event = {
              EVNT_CD: opt.EVNT_CD,
              EVNT_NM: opt.EVNT_NM,
              EVNT_KEY_TYPE: opt.EVNT_KIND_CD,
              EVNT_FLG_CD: opt.EVNT_FLG_CD,
              DC_FLG_CD: opt.EVNT_DC_FLG_CD,
              DC_ITEM_QTY: basket.SALES_QTY,
              DC_AMT: opt.EVNT_DC_AMT,
              EVNT_ITEM_CD: opt.EVNT_ITEM_CD,
              DC_RATE: opt.EVNT_DC_AMT,
              EVNT_FROM_DATE: opt.EVNT_FROM_DATE,
              EVNT_END_DATE: opt.EVNT_END_DATE,
              TIME_SALE_YN: opt.TIME_SALE_YN,
              TIME_SALE_FROM_TIME: opt.TIME_SALE_FROM_TIME,
              TIME_SALE_END_TIME: opt.TIME_SALE_END_TIME,
            };
            eventItem.push(event);
          }

          option.EVENTITEM = eventItem;

          optionitem.push(option);
        });

        let itemName;
        if (posConfig.defaultLanguage == 'KO') itemName = basket.DIS_ITEM_NM_KO;
        else if (posConfig.defaultLanguage == 'JP') itemName = basket.DIS_ITEM_NM_JP;
        else if (posConfig.defaultLanguage == 'EN') itemName = basket.DIS_ITEM_NM_EN;
        else if (posConfig.defaultLanguage == 'CH') itemName = basket.DIS_ITEM_NM_CN;
        else if (posConfig.defaultLanguage == 'TW') itemName = basket.DIS_ITEM_NM_TW;

        // 행사 정보 (상품)
        let eventItem = new Array();
        if (basket.EVNT_ITEM_CD != '' && basket.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: basket.EVNT_CD,
            EVNT_NM: basket.EVNT_NM,
            EVNT_KEY_TYPE: basket.EVNT_KIND_CD,
            EVNT_FLG_CD: basket.EVNT_FLG_CD,
            DC_FLG_CD: basket.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: basket.SALES_QTY,
            DC_AMT: basket.EVNT_DC_AMT,
            EVNT_ITEM_CD: basket.EVNT_ITEM_CD,
            DC_RATE: basket.EVNT_DC_AMT,
            EVNT_FROM_DATE: basket.EVNT_FROM_DATE,
            EVNT_END_DATE: basket.EVNT_END_DATE,
            TIME_SALE_YN: basket.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: basket.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: basket.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        let item = {
          ITEM_CD: basket.DIS_ITEM_CD,
          ITEM_NM: basket.DIS_ITEM_NM,
          ORG_ITEM_NM: itemName,
          CLAS_L_CD: basket.CLAS_L_CD,
          CLAS_M_CD: basket.CLAS_M_CD,
          CLAS_S_CD: basket.CLAS_S_CD,
          TAX_FLG_CD: basket.TAX_FLG_CD,
          TAX_RDC_FLG_CD: basket.TAX_RDC_FLG_CD,
          NRML_UPRC: basket.SALE_UPRC,
          SALES_QTY: basket.SALES_QTY,
          SALES_UPRC: basket.SALE_UPRC,
          ORG_SALES_UPRC: basket.SALE_UPRC,
          DC_ABLE_YN: basket.DC_ABLE_YN,
          DC_AMT: 0.0,
          SALES_AMT: 0,
          VAT_AMT: 0,
          VAT_RATE: basket.TAX_RATE,
          SVC_AMT: 0,
          SUPY_UPRC: basket.SUPY_UPRC,
          MG_RATE: basket.MG_RATE,
          OPTIONITEM: optionitem,
          EVENTITEM: eventItem,
        };
        itemList.push(item);
      });

      let jsonObj = {
        ITEMLIST: itemList,
        EXTRA: {
          ORDER_TYPE: this.$store.getters.getOrderType,
        },
      };

      let tranObj = _.cloneDeep(jsonObj);

      // 상품 가격 계산 (상품할인 행사 포함)
      chargeHelper.calculate(tranObj, posConfig);

      // 영수증 금액 할인 행사 계산
      if (this.receiptDiscount != null) {
        chargeHelper.receipt(tranObj, posConfig, this.receiptDiscount);
      }

      tranObj.ITEMLIST.forEach((basket) => {
        let sum = 0;
        basket.OPTIONITEM.forEach((opt) => {
          sum += opt.SALES_UPRC;
        });
        basket.TOTAL_UPRC = (basket.SALES_UPRC + sum) * basket.SALES_QTY;
      });
      //console.log(tranObj);
      this.$store.dispatch('setBaskets', tranObj);

      if (this.idleScreenOrderType == '04') {
        this.$logInfo(`Payment Start Order Select Type`);
        this.orderSelectYn = true;
      } else {
        let recList = this.$store.getters.getRecommendItem;
        let excludeList = new Array();
        recList.forEach((item) => {
          excludeList.push(item);
          this.baskets.forEach((bas) => {
            if (item.DIS_ITEM_CD === bas.DIS_ITEM_CD) excludeList.pop();
          });
        });

        if (recList.length == 0 || excludeList == 0 || !this.recommendYn) {
          this.$logInfo(`Payment Start Order Select Type`);
          this.$router.replace('/user/payment');
        } else {
          this.$logInfo(`Payment Start Order Select Type`);
          this.menuEventYn = true;
        }
      }
    },
    basketDel() {
      this.baskets = [];
      this.basketDelYn = false;
      this.$store.dispatch('setOrgBaskets', []);
    },
    RegistrationPayOrder(type) {
      this.settleType = type;

      // 장바구니 담기
      let itemList = new Array();
      const posConfig = this.$store.getters.getPosConfig.posConfig;
      this.baskets.forEach((basket) => {
        let optionitem = new Array();
        basket.OPTIONITEM.forEach((opt) => {
          let option = opt;
          option.SALES_QTY = basket.SALES_QTY;
          optionitem.push(option);
        });

        let itemName;
        if (posConfig.defaultLanguage == 'KO') itemName = basket.DIS_ITEM_NM_KO;
        else if (posConfig.defaultLanguage == 'JP') itemName = basket.DIS_ITEM_NM_JP;
        else if (posConfig.defaultLanguage == 'EN') itemName = basket.DIS_ITEM_NM_EN;
        else if (posConfig.defaultLanguage == 'CH') itemName = basket.DIS_ITEM_NM_CN;
        else if (posConfig.defaultLanguage == 'TW') itemName = basket.DIS_ITEM_NM_TW;

        // 행사 정보
        let eventItem = new Array();
        if (basket.EVNT_ITEM_CD != '' && basket.EVNT_ITEM_CD != null) {
          let event = {
            EVNT_CD: basket.EVNT_CD,
            EVNT_NM: basket.EVNT_NM,
            EVNT_KEY_TYPE: basket.EVNT_KIND_CD,
            EVNT_FLG_CD: basket.EVNT_FLG_CD,
            DC_FLG_CD: basket.EVNT_DC_FLG_CD,
            DC_ITEM_QTY: basket.SALES_QTY,
            DC_AMT: basket.EVNT_DC_AMT,
            EVNT_ITEM_CD: basket.EVNT_ITEM_CD,
            DC_RATE: basket.EVNT_DC_AMT,
            EVNT_FROM_DATE: basket.EVNT_FROM_DATE,
            EVNT_END_DATE: basket.EVNT_END_DATE,
            TIME_SALE_YN: basket.TIME_SALE_YN,
            TIME_SALE_FROM_TIME: basket.TIME_SALE_FROM_TIME,
            TIME_SALE_END_TIME: basket.TIME_SALE_END_TIME,
          };
          eventItem.push(event);
        }

        let item = {
          ITEM_CD: basket.DIS_ITEM_CD,
          ITEM_NM: basket.DIS_ITEM_NM,
          ORG_ITEM_NM: itemName,
          CLAS_L_CD: basket.CLAS_L_CD,
          CLAS_M_CD: basket.CLAS_M_CD,
          CLAS_S_CD: basket.CLAS_S_CD,
          TAX_FLG_CD: basket.TAX_FLG_CD,
          TAX_RDC_FLG_CD: basket.TAX_RDC_FLG_CD,
          NRML_UPRC: basket.SALE_UPRC,
          SALES_QTY: basket.SALES_QTY,
          SALES_UPRC: basket.SALE_UPRC,
          ORG_SALES_UPRC: basket.SALE_UPRC,
          DC_ABLE_YN: basket.DC_ABLE_YN,
          DC_AMT: 0.0,
          SALES_AMT: 0,
          VAT_AMT: 0,
          VAT_RATE: basket.TAX_RATE,
          SVC_AMT: 0,
          SUPY_UPRC: basket.SUPY_UPRC,
          MG_RATE: basket.MG_RATE,
          OPTIONITEM: optionitem,
          EVENTITEM: eventItem,
        };
        itemList.push(item);
      });

      let jsonObj = {
        ITEMLIST: itemList,
        EXTRA: {
          ORDER_TYPE: this.$store.getters.getOrderType,
        },
      };

      let tranObj = _.cloneDeep(jsonObj);

      // 상품 가격 계산 (상품할인 행사 포함)
      chargeHelper.calculate(tranObj, posConfig);

      // 영수증 금액 할인 행사 계산
      if (this.receiptDiscount != null) {
        chargeHelper.receipt(tranObj, posConfig, this.receiptDiscount);
      }

      tranObj.ITEMLIST.forEach((basket) => {
        let sum = 0;
        basket.OPTIONITEM.forEach((opt) => {
          sum += opt.SALES_UPRC;
        });
        basket.TOTAL_UPRC = (basket.SALES_UPRC + sum) * basket.SALES_QTY;
      });
      //console.log(tranObj);
      this.$store.dispatch('setBaskets', tranObj);

      // this.registrationPayYn = true;
      this.registrationIngYn = true;
    },
    totOptUprc(item) {
      let sum = 0;
      item.OPTIONITEM.forEach((opt) => {
        sum += this.$detailUprc(opt);
      });
      return sum;
    },
  },
  beforeMount() {},
  mounted() {
    //언어 변경
    if (this.$i18n.locale == 'jp') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_JP;
        item.ITEM_DESC = item.ITEM_DESC_JP;
      });
    } else if (this.$i18n.locale == 'ko') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_KO;
        item.ITEM_DESC = item.ITEM_DESC_KO;
      });
    } else if (this.$i18n.locale == 'en') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_EN;
        item.ITEM_DESC = item.ITEM_DESC_EN;
      });
    } else if (this.$i18n.locale == 'cn') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_CN;
        item.ITEM_DESC = item.ITEM_DESC_CN;
      });
    } else if (this.$i18n.locale == 'tw') {
      this.kioskItem.forEach((item) => {
        item.DIS_ITEM_NM = item.DIS_ITEM_NM_TW;
        item.ITEM_DESC = item.ITEM_DESC_TW;
      });
    }

    if (this.$store.getters.getOrgBaskets != null) this.baskets = this.$store.getters.getOrgBaskets;

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      audioHelper.playAudio('00101', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }

    this.$changeDarkMode(this.darkModeYn);
    this.$showButtonAnimation();

    document.getElementById('adminArea').style.zIndex = 0;
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  data() {
    return {
      activeBtn: this.$store.state.masterData.TB_MST_KIOSK_CLAS[0].KOS_CLASS_CD,
      kioskItem: this.$store.getters.getKioskItem,
      currUnitText: this.$store.getters.getCurrUnitText,
      pageCount: 10,
      currentPage: 1,
      menuPersonalYn: false,
      orderSelectYn: false,
      menuEventYn: false,
      orderType: this.$store.getters.getOrderType,
      baskets: [],
      itemObj: {},
      algCheckd: [],
      basketDelYn: false,
      adminLoginYn: false,
      adminCnt: 0,
      adminCnt2: 0,
      darkModeYn: this.$store.getters.getDarkModeYn,
      adminModeYn: this.$store.getters.getAdminModeYn,
      allergys: this.$store.getters.getAllergys,
      allergyCd: '',
      allergySelectedList: [],
      idx: 1,
      basketKey: 0,
      adType: '',
      adSrc: '',
      adNum: 0,
      headerPage: 1,
      registrationPayYn: false,
      registrationIngYn: false,
      registrationFinishYn: false,
      //알레르기 필터 여부
      algYn: this.$store.getters.getPosConfig.posConfig.useAllergyFilter,
      //추천상품 노출 여부
      recommendYn: this.$store.getters.getPosConfig.posConfig.recommendProductExposure,
      //주문 방법 선택 여부
      idleScreenOrderType: this.$store.getters.getPosConfig.posConfig.idleScreenOrderType,
      //부가세율
      taxRate: this.$store.getters.getPosConfig.posConfig.taxRate,
      //경감세율
      reducedTaxRate: this.$store.getters.getPosConfig.posConfig.reducedTaxRate,
      //세금 판매가 포함 여부
      isTaxIncluded: this.$store.getters.getPosConfig.posConfig.isTaxIncluded,
      helperYn: false,
      staffCallYn: false,
      staffCallFinishYn: false,
      alertHomeYn: false,
      allergyYn: false,
      //alert 창에 표시할 메세지
      text: '',
      message: '',
      alertYn: false,
      paymentErrorYn: false,
      settleType: '',
      receiptDiscount: this.$store.getters.getReceiptDiscount,
    };
  },
  components: {
    MainPaging: mainPaging,
    MenuPersonalVue: menuPersonalVue,
    OrderSelect: orderSelect,
    MenuEvent: menuEvent,
    BasketDel: basketDel,
    AdminLogin: adminLogin,
    RegistrationPay: registrationPay,
    RegistrationFinish: registrationFinish,
    RegistrationIng: registrationIng,
    HelperHeight: helperHeight,
    Helper: helper,
    StaffCall: staffCall,
    StaffCallFinish: staffCallFinish,
    AlertHome: alertHome,
    Allergy: allergy,
    AlertVue: alertVue,
    PaymentError: paymentError,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
    adminMode: function () {
      return this.$store.getters.getAdminModeYn;
    },
    totalUprc() {
      let sum = 0;
      this.baskets.forEach((item) => {
        let optSum = 0;
        item.OPTIONITEM.forEach((opt) => {
          optSum += this.$detailUprc(opt);
        });
        sum += item.SALES_QTY * (this.$detailUprc(item) + optSum);
      });

      return this.$displayUprc(sum);
    },
    classification() {},
    totalCount() {
      return this.kioskItem.length;
    },
    totalQty() {
      let sum = 0;
      this.baskets.forEach((item) => {
        sum += item.SALES_QTY;
      });

      return sum;
    },
  },
  watch: {
    darkMode(value) {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    menuPersonalYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00102', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    adminMode(val) {
      this.adminModeYn = this.adminModeYn ? false : true;
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/main.css" scoped></style>
<style src="@/assets/css/user/pages/main-e.css" scoped></style>
<style src="@/assets/css/user/pages/table.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/main-dark.css" scoped></style>
<style src="@/assets/css/user/dark/main-e-dark.css" scoped></style>
<style src="@/assets/css/user/pages/admin.css" scoped></style>
<style scoped>
body {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: 'NotoSansKR', sans-serif;
  font-size: 20px;
  font-weight: 600;
  color: var(--primary-ft-color);
  line-height: 1.3em;
  -webkit-text-size-adjust: none;
  background: var(--bg-color);
}
@media only screen and (min-width: 2000px) {
  body {
    font-size: 40px !important;
  }
}

.toggle-wrap {
  position: absolute;
  top: 40%;
  left: 22%;
}

.admin .toggle-wrap {
  opacity: 1 !important;
  z-index: 1;
}

.large .toggle-wrap {
  top: 45%;
  left: 38%;
}
.scheduleArea {
  height: 15.5vh;
} 
</style>
